<template>
  <div>
    <v-container v-if="displayPage" class="payment-page">
      <v-row dense>
        <v-col cols="1">
          <router-link to="/payment-plan" class="back-arrow"
            ><v-icon large class="mr-4">{{
              icons.mdiArrowLeft
            }}</v-icon></router-link
          >
        </v-col>
        <v-col cols="12" sm="11" class="pb-12">
          <h1>How would you like to pay</h1>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="4" offset-md="1" class="text-center">
          <div class="payment-selected py-4">
            <p>YOUR WILL</p>
            <p class="price">R{{ onceOffPrice }} once off</p>
          </div>
        </v-col>
        <v-col cols="12" md="6" offset-md="1">
          <PaymentAccordion payment-plan="ONCE_OFF" />
        </v-col>
      </v-row>
    </v-container>

    <div v-else class="text-center mt-12">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <PaymentProviderReturn
      payment-plan="ONCE_OFF"
      @no-payment-provider-data="displayPage = true"
      @payment-error="displayPage = true"
    />
  </div>
</template>

<script>
  import PaymentAccordion from './PaymentAccordion.vue';
  import PaymentProviderReturn from './PaymentProviderReturn.vue';
  import PaymentQuestions from './PaymentQuestions.vue';

  export default {
    name: 'BasicPaymentPage',
    components: {
      PaymentAccordion,
      PaymentProviderReturn,
      PaymentQuestions,
    },
    data() {
      return {
        displayPage: false,
      };
    },
    computed: {
      onceOffPrice() {
        return process.env.VUE_APP_ONCE_OFF_PRICE;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .payment-selected {
    // border and background color in global.scss because of IE issue
    border-radius: 7px;
    font-weight: bold;

    p {
      line-height: 30px;
      margin-bottom: 0px;
    }

    .price {
      background-color: black;
      color: #fff;
      width: 75%;
      border: 1px solid bottom;
      border-radius: 7px;
      margin: auto;
      padding-left: 3px;
      padding-right: 3px;
    }
  }

  @media screen and (max-width: 960px) {
    .payment-selected {
      margin-bottom: 10px;
    }
  }
</style>
